import React, { useState, useEffect } from "react";
import {
  DialogActions,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  TextField,
  Checkbox,
  FormControlLabel,
  MenuItem,
  Select,
  FormControl,
} from "@material-ui/core";
import { useTranslation } from "react-i18next";
import InputLabel from "@material-ui/core/InputLabel";
import { makeStyles } from "@material-ui/core/styles";
import ManageAttachments from "../../../administration/ManageAttachments";

const useStyles = makeStyles((theme) => ({
  formControl: {
    marginBottom: 5,
    width: "100%",
  },
}));
function GlobalAttachmentsDialog(props) {
  const classes = useStyles();
  const [selectedAttachment, setSelectedAttachment] = useState({});
  const { t } = useTranslation();

  return (
    <Dialog
      fullWidth
      fullScreen
      open={props.open}
      onClose={props.onClose}
      PaperProps={{ style: { overflow: "inherit" } }}
      // style={{ zIndex: 1305 }}
    >
      {/* <DialogTitle>
        CustomFields
      </DialogTitle> */}
      <DialogContent>
        <ManageAttachments
          editorDialog
          selectedAttachment={selectedAttachment}
          onSelection={setSelectedAttachment}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={props.onClose} color="default" aria-label="Cancel">
          {t("global_cancel")}
        </Button>
        <Button
          aria-label="Insert button"
          color="default"
          disabled={selectedAttachment.id ? false : true}
          onClick={() => props.onSubmit(selectedAttachment)}
        >
          {t("global_insert")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default GlobalAttachmentsDialog;
